import types from "./types";

const initialState = {
  coachingDataList: [],
  skillsList: [],
  coachingRequestSubmitList: [],
  getSlotsData: {},
  createSlotsData: {},
  addSlotsData: {},
  deleteSlotsData: {},
  registerCoachData: {},
  sessionNotesList: {},
  coachingListing: {},
  addSessionNotes: {},
  coachRating: {},
  coachingPersonalListing: {},
  getcoachRating: {},
  getMasterIndustryData: {},
  coachingServicesData: {},
  coachingServiceDetail: {},
  coachingRequestData: {},
  coachingRequestsListData: {},
  rescheduleSlotsData: {},
  coachingRequestUpdateData: {},
  myBookingList: {},
  aiCoachingUrlData: {},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case types.COACHING_LIST_RESPONSE:
      return {
        ...state,
        coachingDataList: action.payload,
      };
    case types.COACHING_LIST_CLEAR:
      return {
        ...state,
        coachingDataList: [],
      };
    case types.CS_GETSKILL_RESPONSE:
      return {
        ...state,
        skillsList: action.payload,
      };
    case types.CS_GETSKILL_CLEAR:
      return {
        ...state,
        skillsList: [],
      };

    case types.COACHING_REQUEST_SUBMIT_RESPONSE:
      return {
        ...state,
        coachingRequestSubmitList: action.payload,
      };
    case types.COACHING_REQUEST_SUBMIT_CLEAR:
      return {
        ...state,
        coachingRequestSubmitList: [],
      };
    case types.GET_SLOTS_RESPONSE:
      return {
        ...state,
        getSlotsData: action.payload,
      };
    case types.GET_SLOTS_RESPONSE_CLEAR:
      return {
        ...state,
        getSlotsData: [],
      };
    case types.CREATE_SLOTS_RESPONSE:
      return {
        ...state,
        createSlotsData: action.payload,
      };
    case types.CREATE_SLOTS_RESPONSE_CLEAR:
      return {
        ...state,
        createSlotsData: [],
      };
    case types.ADD_SLOTS_RESPONSE:
      return {
        ...state,
        addSlotsData: action.payload,
      };
    case types.ADD_SLOTS_RESPONSE_CLEAR:
      return {
        ...state,
        addSlotsData: [],
      };
    case types.DELETE_SLOTS_RESPONSE:
      return {
        ...state,
        deleteSlotsData: action.payload,
      };
    case types.DELETE_SLOTS_RESPONSE_CLEAR:
      return {
        ...state,
        deleteSlotsData: [],
      };
    case types.REGISTER_COACH_RESPONSE:
      return {
        ...state,
        registerCoachData: action.payload,
      };
    case types.REGISTER_COACH_RESPONSE_CLEAR:
      return {
        ...state,
        registerCoachData: [],
      };
    case types.GET_SESSION_NOTES_LISTING_RESPONSE:
      console.log("actionnn", action);
      return {
        ...state,
        sessionNotesList: action.payload,
      };
    case types.GET_SESSION_NOTES_LISTING_RESPONSE_CLEAR:
      return {
        ...state,
        sessionNotesList: [],
      };

    case types.COACHING_LISTING_RESPONSE:
      return {
        ...state,
        coachingListing: action.payload,
      };
    case types.COACHING_LISTING_CLEAR:
      return {
        ...state,
        coachingListing: {},
      };

    case types.ADD_SESSION_NOTES_RESPONSE:
      return {
        ...state,
        addSessionNotes: action.payload,
      };
    case types.ADD_SESSION_NOTES_RESPONSE_CLEAR:
      return {
        ...state,
        addSessionNotes: {},
      };
    case types.COACH_RATING_RESPONSE:
      return {
        ...state,
        coachRating: action.payload,
      };
    case types.COACH_RATING_RESPONSE_CLEAR:
      return {
        ...state,
        coachRating: {},
      };

    case types.COACHING_PERSONAL_LISTING_RESPONSE:
      return {
        ...state,
        coachingPersonalListing: action.payload,
      };
    case types.COACHING_PERSONAL_LISTING_CLEAR:
      return {
        ...state,
        coachingPersonalListing: {},
      };
    case types.GET_COACH_RATING_RESPONSE:
      return {
        ...state,
        getcoachRating: action.payload,
      };
    case types.GET_COACH_RATING_RESPONSE_CLEAR:
      return {
        ...state,
        getcoachRating: {},
      };
    case types.GET_MASTER_INDUSTRY_DATA_RESPONSE:
      return {
        ...state,
        getMasterIndustryData: action.payload,
      };
    case types.GET_MASTER_INDUSTRY_DATA_RESPONSE_CLEAR:
      return {
        ...state,
        getMasterIndustryData: {},
      };
    case types.GET_COACHING_SERVICES_RESPONSE:
      return {
        ...state,
        coachingServicesData: action.payload,
      };
    case types.GET_COACHING_SERVICES_RESPONSE_CLEAR:
      return {
        ...state,
        coachingServicesData: {},
      };
    case types.GET_COACHING_SERVICE_DETAIL_RESPONSE:
      return {
        ...state,
        coachingServiceDetail: action.payload,
      };
    case types.GET_COACHING_SERVICE_DETAIL_RESPONSE_CLEAR:
      return {
        ...state,
        coachingServiceDetail: {},
      };
    case types.COACHING_REQUEST_SEND_RESPONSE:
      return {
        ...state,
        coachingRequestData: action.payload,
      };
    case types.COACHING_REQUEST_SEND_RESPONSE_CLEAR:
      return {
        ...state,
        coachingRequestData: {},
      };
    case types.COACHING_REQUESTS_LIST_RESPONSE:
      return {
        ...state,
        coachingRequestsListData: action.payload,
      };
    case types.COACHING_REQUESTS_LIST_RESPONSE_CLEAR:
      return {
        ...state,
        coachingRequestsListData: {},
      };
    case types.RESCHEDULE_SLOTS_RESPONSE:
      return {
        ...state,
        rescheduleSlotsData: action.payload,
      };
    case types.RESCHEDULE_SLOTS_RESPONSE_CLEAR:
      return {
        ...state,
        rescheduleSlotsData: [],
      };
    case types.COACHING_REQUESTS_UPDATE_RESPONSE:
      return {
        ...state,
        coachingRequestUpdateData: action.payload,
      };
    case types.COACHING_REQUESTS_UPDATE_RESPONSE_CLEAR:
      return {
        ...state,
        coachingRequestUpdateData: [],
      };
    case types.GET_MY_BOOKING_LIST_RESPONSE:
      return {
        ...state,
        myBookingList: action.payload,
      };
    case types.GET_MY_BOOKING_LIST_RESPONSE_CLEAR:
      return {
        ...state,
        myBookingList: [],
      };
    case types.AI_COACHING_URL_RESPONSE:
      return {
        ...state,
        aiCoachingUrlData: action.payload,
      };
    case types.AI_COACHING_URL_RESPONSE_CLEAR:
      return {
        ...state,
        aiCoachingUrlData: [],
      };
    default:
      return state;
  }
};
